module.exports = __webpack_public_path__ + "img/icon_dining_greyed.2168bb46.png";